<template lang="html">
  <div :class="containerClasses">
    <div class="card__content">
      <component :is="iconName" class="card__icon" />
      <div>
        <div class="card__value">
          {{ formattedValue }}
        </div>
        <div class="card__description">
          <span v-html="description" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Collaborators from './svg/Collaborators.vue'
import House from './svg/House.vue'
import Player from './svg/Player.vue'
import Rocket from './svg/Rocket.vue'

export default {
  components: {
    Collaborators,
    House,
    Player,
    Rocket
  },

  props: {
    value: {
      type: Number,
      required: true
    },
    description: {
      type: String,
      required: true
    },
    color: {
      type: String,
      default: 'pink',
      validator: (value) => {
        return ['pink', 'green', 'purple'].includes(value)
      }
    },
    icon: {
      type: String,
      required: true
    }
  },
  computed: {
    formattedValue () {
      const locale = this.$i18n.locale
      return Intl.NumberFormat(locale, { useGrouping: true }).format(this.value)
    },
    iconName () {
      return this.icon.charAt(0).toUpperCase() + this.icon.slice(1)
    },

    containerClasses () {
      return [
        'card__container',
        `card__container-${this.color ? this.color : 'pink'}`
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.card {
  &__container {
    border-radius: 8px;

    &-pink {
      background: linear-gradient(233.67deg, #FC3BB2 17.12%, #F7906E 92.58%);
      color: white;
      /deep/ strong {
        color: white;
      }
    }

    &-green {
      background: linear-gradient(90deg, #57EBDE 0%, #AEFB2A 100%);
      color: black;
      /deep/  strong {
        color: black;
      }
    }

    &-purple {
      background: linear-gradient(334.94deg, #4646FB -2.11%, #BE4DFF 55.21%, #BC9AFF 112.52%);
      color: white;
      /deep/  strong {
        color: white;
      }
    }
  }

  &__content {
    padding: $gap * 1.5;
    display: flex;
    height: 100%;
    flex-direction: column;
    justify-content: space-between;
  }

  &__value {
    font-size: 56px;
    font-weight: 700;
    margin-bottom: $gap;

    @include display-less(desktop) {
      font-size: 48px;
    }
  }

  &__icon {
    margin-left: auto;
    width: 56px;
    height: 56px;
  }

  &__description {
    font-size: 28px;
    line-height: 100%;
  }
}
</style>
